export const Logo = ({ variant = "dark", className = "" }) => {
  const isLight = variant === "light";
  const panel = isLight ? "#FFFFFF" : "#1E5EDB";
  const grid = isLight ? "#0A2342" : "#FFFFFF";
  const top = isLight ? "text-white" : "text-[#0A2342]";
  const sub = isLight ? "text-white/70" : "text-[#1E5EDB]";

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg width="40" height="40" viewBox="0 0 48 48" fill="none" className="shrink-0">
        <path d="M6 21 L24 8 L42 21" stroke={panel} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="9" y="20" width="30" height="21" rx="2.5" fill={panel} />
        <g stroke={grid} strokeWidth="1.4" opacity="0.9">
          <line x1="19" y1="20" x2="19" y2="41" />
          <line x1="29" y1="20" x2="29" y2="41" />
          <line x1="9" y1="27" x2="39" y2="27" />
          <line x1="9" y1="34" x2="39" y2="34" />
        </g>
      </svg>
      <span className="flex flex-col leading-none">
        <span className={`font-display font-extrabold tracking-tight text-[20px] ${top}`}>
          SOLAR PROS
        </span>
        <span className={`font-display font-semibold tracking-[0.18em] text-[9.5px] ${sub}`}>
          CLEANING SERVICES
        </span>
      </span>
    </span>
  );
};
